import { useEffect, useState } from 'react';
import {
  BILINGUE_RECOMMANDE,
  LANGUES_CHARTE,
  LANGUE_CHARTE_PAR_DEFAUT,
  LIBELLES_LANGUE_CHARTE,
  type BaremeApplicable,
  type CharteEditee,
  type LangueCharte,
} from '@rh/shared';
import { appel } from '../api';
import { Erreur } from './Etat';

/**
 * Édition de la charte vierge à imprimer (docs/CHARTES.md). La langue proposée
 * suit la famille du poste : arabe pour le terrain, français pour les bureaux,
 * bilingue signalé comme recommandé pour le terrain.
 */
export function EditerCharte({
  candidatureId,
  onEditee,
}: {
  candidatureId: string;
  onEditee: (charte: CharteEditee) => void;
}) {
  const [langue, setLangue] = useState<LangueCharte | ''>('');
  const [recommande, setRecommande] = useState(false);
  const [erreur, setErreur] = useState<string | null>(null);
  const [envoi, setEnvoi] = useState(false);

  useEffect(() => {
    appel<BaremeApplicable>(`/candidatures/${candidatureId}/bareme`)
      .then((bareme) => {
        const groupe = bareme.groupe;
        setLangue((actuelle) => actuelle || (groupe ? LANGUE_CHARTE_PAR_DEFAUT[groupe] : 'fr'));
        setRecommande(groupe !== null && BILINGUE_RECOMMANDE.includes(groupe));
      })
      .catch(() => setLangue((actuelle) => actuelle || 'fr'));
  }, [candidatureId]);

  async function editer(): Promise<void> {
    if (!langue) return;
    setErreur(null);
    setEnvoi(true);
    try {
      onEditee(
        await appel<CharteEditee>(`/candidatures/${candidatureId}/charte`, {
          method: 'POST',
          body: JSON.stringify({ langue }),
        }),
      );
    } catch (e) {
      setErreur(e instanceof Error ? e.message : 'Édition de la charte impossible');
    } finally {
      setEnvoi(false);
    }
  }

  return (
    <div className="changer-statut">
      <select
        value={langue}
        aria-label="Langue de la charte"
        onChange={(e) => setLangue(e.target.value as LangueCharte)}
      >
        {LANGUES_CHARTE.map((l) => (
          <option key={l} value={l}>
            {LIBELLES_LANGUE_CHARTE[l]}
            {l === 'bilingue' && recommande ? ' — recommandé' : ''}
          </option>
        ))}
      </select>
      <button type="button" className="bouton-second" disabled={envoi || !langue} onClick={() => void editer()}>
        {envoi ? 'Génération…' : 'Éditer la charte'}
      </button>
      {erreur && <Erreur message={erreur} />}
    </div>
  );
}
